<template>
  <div class="ticket">
    <!-- 头部 -->
    <!-- <Header>TicketMonitoring票务监测</Header> -->
        <!-- 内容区 -->
    <!-- <div class="content">
        <Echarts></Echarts>
    </div> -->
       <router-link to="/Home" class="home"></router-link>
      <router-link to="/Home" class="exit"></router-link>
  </div>
</template>

<script>
// import Echarts from '../../components/Echarts.vue'
// import Header from '../../components/Header.vue';
export default {
 // components: { Echarts, Header },
  name:'TicketMonitoring', // 票务监测
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.ticket {

   width: 100vw;
  height: 100vh;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;

   background-image: url("../../assets/image/test/ticket.jpg");
  .home{
    width: rpx(86);
    height: rpx(49);
    position:absolute;
    
    top: rpx(51);
    right: rpx(313);
  }
  .exit{
     width: rpx(86);
    height: rpx(49);
    position:absolute;

    top: rpx(51);
    right: rpx(20);
  }

  header {
    width: 100%;
    height: 10%;
    background: rgba(255, 0, 0); // 头部
  }
  .content {
    width: 100%;
    height: 70%;
    background: rgba(198, 224, 47, 0.301);
  }
}
</style>